<template lang="html">
  <span class="atlas-country"></span>
</template>

<script>
export default {
  name: 'AtlasCountry',
  props: {
    coords: {
      type: Array
    },
    code: {
      type: String
    },
    flag: {
      type: Boolean
    }
  }
}
</script>

<style lang="css">
</style>
